import userCourseHistoryApi from 'Api/axios/user-course-histories-api';
import { useEffect, useState } from 'react';
import type { HistoryReportFilterI, HistoryReportI, PaginationMetaI } from 'types';

interface Props {
  init?: boolean;
}

const useHistoryReportApi = ({ init = false }: Props) => {
  const [data, setData] = useState<HistoryReportI[]>([]);
  const [pagination, setPagination] = useState<PaginationMetaI | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchHistoryReport = async (filters: HistoryReportFilterI = {}) => {
    setLoading(true);
    setError(null);

    const response = await userCourseHistoryApi.getEmployeesCollection(filters);

    setLoading(false);

    if (response.data) {
      setData(response.data ?? []);
      setPagination(response.pagination ?? null);
    } else {
      setError(response.error ?? 'No hay datos disponibles');
    }
  };

  useEffect(() => {
    if (init) {
      fetchHistoryReport({ page: 1, limit: 15 });
    }
  }, [init]);

  return { data, pagination, loading, error, fetchHistoryReport };
};

export default useHistoryReportApi;
